"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationSetting',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationSettingListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    }
  }
};